import React, { Component } from 'react'
import ItemQC from './ItemQC'
import ItemQCnotMask from './ItemQCnotMask'
import PropTypes from "prop-types"
import className from 'classnames'
import { Icon, Popconfirm, Modal, Radio, Button, Input } from "antd"
import { ERROR_DETAIL } from '../../helpers/errorDetail.json'
import QchtDescriptionBox from './QchtDescriptionBox'
import { resolveBrandDescriptions } from '../../helpers/brandDescription'

class ListItemsQC extends Component {
    state = {
        name: '',
        textLoading: 'Đang tải...'
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.selectedItem !== this.props.selectedItem || prevProps.foundBasket !== this.props.foundBasket || prevProps.totalItems !== this.props.totalItems) {
            this._checkName()
        }
    }

    componentDidMount() {
        this._checkName()
    }

    _toggleSelectAll = (e) => {
        const { checked } = e.target
        const { toggleSelectAll } = this.props

        toggleSelectAll(checked)
    }

    _cancelQC = (e) => {
        e.preventDefault()
        const { cancelQC } = this.props

        cancelQC()
    }

    _submitQC = (e) => {
        e.preventDefault()

        const { submitQC } = this.props

        if (typeof submitQC === 'function') {
            submitQC()
        }
    }
    _submitQC1ST = (e) => {
        e.preventDefault()

        const { submitQC1ST } = this.props

        if (typeof submitQC1ST === 'function') {
            submitQC1ST()
        }
    }

    _checkName = () => {
        const { foundBasket, totalItems, typeQC, selectedItem, defaultChecked, isAddBasket } = this.props

        if (totalItems === 1) {
            this.setState({
                name: 'Đánh dấu QC'
            })
        } else {
            if (!foundBasket) {
                if (typeQC) {
                    if ((selectedItem.length + defaultChecked.length < totalItems) && isAddBasket) {
                        this.setState({
                            name: 'Tạo giỏ'
                        })

                    } else {
                        this.setState({
                            name: 'Đánh dấu QC'
                        })
                    }
                } else {
                    this.setState({
                        name: 'Đánh dấu QC'
                    })
                }
            } else {
                if (typeQC) {
                    if ((selectedItem.length + defaultChecked.length < totalItems) && isAddBasket) {
                        this.setState({
                            name: 'Thêm vào giỏ'
                        })
                    } else {
                        this.setState({
                            name: 'Đánh dấu QC'
                        })
                    }
                } else {
                    this.setState({
                        name: 'Đánh dấu QC'
                    })
                }
            }
        }
    }

    render() {
        const { name, textLoading } = this.state
        const {
            allItems,
            loading,
            loadingQC1ST,
            selectedItem,
            defaultChecked,
            allSelected,
            updateOrdersSelected,
            typeQC,
            oneItem,
            outItems,
            inputValue,
            totalItems,
            reset,
            relatedSkuWithInputBarcode,
            refocusInput,
            handleCheckError,
            arrCheckError,
            onCloseModal,
            onOpenModal,
            onMarkItemError,
            isOpen,
            handleChangeRadio,
            sku,
            skuSizes,
            orderItem,
            isPhotoRequest,
        } = this.props
        const dataMark = typeQC ? allItems : oneItem
        //Đơn chỉ có 1 item thì mô tả QCHT hiển thị luôn trên giao diện, không phải mở popup ở MarkQC.
        //Dùng lại resolveBrandDescriptions để quy tắc brand -> DEFAULT không bị viết lại lần 2.
        const isSingleItemMultiQC = !!typeQC && totalItems === 1
        const { brands_description_packaged: brandsDescriptionPackaged = [] } = { ...relatedSkuWithInputBarcode }
        const [singleItem = {}] = isSingleItemMultiQC ? dataMark : []
        const inlineDescriptions = isSingleItemMultiQC
            ? resolveBrandDescriptions(brandsDescriptionPackaged, singleItem.brand_name || '')
            : []
        const itemsSelectedError = allItems.filter(item => item.hasOwnProperty('tool3d_order') && arrCheckError.includes(item.tool3d_order._id))
        const isAllowMarkItemError = !!itemsSelectedError && !!itemsSelectedError.length && itemsSelectedError.every(i => !!i.error_detail && !!i.error_type)

        return (
            <div>
                {
                    dataMark.length > 0 && (
                        <div className={className('listDataQC row', typeQC ? 'QCMark' : '')}>
                            {dataMark.map(item => {
                                return (
                                    <div key={item._id}
                                        className={className('mt-3', typeQC ? 'col-sm-3' : 'col-sm-12')}>
                                        <div
                                            className={className('itemQC', defaultChecked.includes(item._id) && 'isBasket')}>
                                            {
                                                typeQC ? (
                                                    <ItemQC
                                                        item={item}
                                                        defaultChecked={defaultChecked}
                                                        arrChecked={selectedItem}
                                                        updateOrdersSelected={updateOrdersSelected}
                                                        handleCheckError={handleCheckError}
                                                        arrCheckError={arrCheckError}
                                                    />
                                                ) : (
                                                    <ItemQCnotMask
                                                        item={item}
                                                        totalItems={totalItems}
                                                        allItems={allItems}
                                                        outItems={outItems}
                                                        defaultChecked={defaultChecked}
                                                        arrChecked={selectedItem}
                                                        updateOrdersSelected={updateOrdersSelected}
                                                        cancelQC={this._cancelQC}
                                                        typeQC={typeQC}
                                                        allSelected={allSelected}
                                                        toggleSelectAll={this._toggleSelectAll}
                                                        loading={loading}
                                                        loadingQC1ST={loadingQC1ST}
                                                        selectedItem={selectedItem}
                                                        textLoading={textLoading}
                                                        name={name}
                                                        inputValue={inputValue}
                                                        reset={reset}
                                                        submitQC={this._submitQC}
                                                        submitQC1ST={this._submitQC1ST}
                                                        relatedSkuWithInputBarcode={relatedSkuWithInputBarcode}
                                                        refocusInput={refocusInput}
                                                        sku={sku}
                                                        skuSizes={skuSizes}
                                                        orderItem={orderItem}
                                                        isPhotoRequest={isPhotoRequest}
                                                    />
                                                )
                                            }

                                        </div>
                                    </div>
                                )
                            })
                            }
                            {
                                /* Đơn chỉ có 1 item: mô tả QCHT nằm ở mép phải của hàng, tách khỏi card ảnh item.
                                   ml-auto đẩy cột về sát phải; .foot đã được scss ép flex 0 0 100%
                                   nên vẫn tự xuống dòng bên dưới. */
                                isSingleItemMultiQC && !!inlineDescriptions.length &&
                                <div className="col-sm-4 mt-3 ml-auto QchtInline">
                                    <QchtDescriptionBox
                                        descriptions={inlineDescriptions}
                                        className=""
                                        onClosePreview={refocusInput}
                                    />
                                </div>
                            }
                            {typeQC && (
                                <div className="foot d-flex align-items-center justify-content-between w-100 col-5">
                                    <button type="button" onClick={this._cancelQC}
                                        className="btn btn-outline-secondary">
                                        Hủy
                                    </button>
                                    <div className="d-flex align-items-center justify-content-end">
                                        {
                                            typeQC && <div className='d-flex align-items-center'>
                                                <input className="mr-2" checked={allSelected} readOnly id="checkAll"
                                                    type="checkbox"
                                                    onClick={this._toggleSelectAll} />
                                                <label htmlFor="checkAll">Chọn tất cả</label>
                                            </div>
                                        }
                                        {
                                            (loading || selectedItem.length === 0) ?
                                                <button type="button" disabled={loading || !(arrCheckError.length + defaultChecked.length === totalItems)}
                                                    className="btn btn-primary ml-3 btn-lg" onClick={onOpenModal}>
                                                    {
                                                        loading ? textLoading : (arrCheckError.length + defaultChecked.length === totalItems) ? "Đánh dấu lỗi" : name
                                                    }
                                                </button> :
                                                <Popconfirm placement={typeQC ? 'topRight' : 'topRight'}
                                                    className='CustomPopConfirm'
                                                    icon={<Icon type="question-circle" />}
                                                    title={`Bạn chắc chắn muốn ${name} cho sản phẩm này?`}
                                                    onConfirm={this._submitQC} okText={name}
                                                    cancelText="Hủy">
                                                    <button type="button"
                                                        disabled={loading || selectedItem.length === 0}
                                                        className="btn btn-primary ml-3 btn-lg">
                                                        {
                                                            loading ? textLoading : name
                                                        }
                                                    </button>
                                                </Popconfirm>
                                        }
                                        {itemsSelectedError.length > 0 && <Modal
                                            visible={isOpen}
                                            title="Đánh dấu lỗi"
                                            onOk={onMarkItemError}
                                            onCancel={onCloseModal}
                                            className={`MarkItemErrorModal MarkItemModalQCComplete ${itemsSelectedError.length === 1 && 'markNoMultiple'}`}
                                            footer={[
                                                <Button key="back" onClick={onCloseModal}>
                                                    Hủy
                                                </Button>,
                                                <Button key="submit" type="danger" loading={loading} onClick={onMarkItemError} disabled={!isAllowMarkItemError}>
                                                    Đánh dấu lỗi
                                                </Button>
                                            ]}
                                        >
                                            {
                                                itemsSelectedError.length > 0 && itemsSelectedError.map((item, index) => {
                                                    const { tool3d_order } = { ...item }
                                                    const { barcode_number, item_number, preview_image } = { ...tool3d_order }

                                                    return (
                                                        <div className={`Content pb-2 d-flex align-items-center justify-content-between ${itemsSelectedError.length > 1 ? 'border-bottom' : ''}`} key={`${index}_item`}>
                                                            <div className="infoItem">
                                                                <div className="barcode_item h4">
                                                                    <b>{`#${barcode_number}_${item_number}`}</b>
                                                                </div>
                                                                <div className="previewItem">
                                                                    <img src={preview_image} alt="preview" width={100} />
                                                                </div>
                                                            </div>
                                                            <div className="ErrorStyle">
                                                                <div className="list-error-detail">
                                                                    {ERROR_DETAIL.map((error, i) => (
                                                                        <div key={i} className={`error-item ${item.error_detail === error.name ? 'error-bg' : ''}`} onClick={() => handleChangeRadio(error.name, item)}>
                                                                            {error.name}
                                                                        </div>
                                                                    ))}
                                                                    <div>
                                                                        <Input
                                                                            placeholder='Nhập lỗi khác'
                                                                            style={{ height: 37, textAlign: 'center' }}
                                                                            onChange={e => handleChangeRadio(e.target.value, item)}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </Modal>}
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
            </div>
        )
    }
}

ListItemsQC.propTypes = {
    loading: PropTypes.bool.isRequired,
    totalItems: PropTypes.number.isRequired,
    allItems: PropTypes.array.isRequired,
    outItems: PropTypes.array,
    typeQC: PropTypes.bool,
    oneItem: PropTypes.array,
    defaultChecked: PropTypes.array,
    allSelected: PropTypes.bool.isRequired,
    selectedItem: PropTypes.array,

    updateOrdersSelected: PropTypes.func.isRequired,
    toggleSelectAll: PropTypes.func.isRequired,
    cancelQC: PropTypes.func.isRequired,
    submitQC: PropTypes.func.isRequired
}

export default ListItemsQC